import React, { Component } from 'react'
import { createStyles, WithStyles, withStyles, Theme } from '@material-ui/core'
import { CONTENT_TYPE, SOURCE_TYPE, LANGUAGES, JUDICIAL_DOCUMENT, OUTCOME_OF_TRIAL, PHASE_OF_CASE, TYPE_OF_JUDICIAL_DOCUMENT, TYPE_OF_COURT, ICC_SITUATION_NAME, BOOLEAN_OPTIONS } from '../../Features/AddNewLTDDocument/@types'
import FormGroup, { IFormConfig } from '../FormGroup'
import { connect } from 'react-redux'
import { ONewLTDDocument } from '../../Features/AddNewLTDDocument/redux-config'
import { OApp } from '../../RootReducer/AppReducer'
import _ from 'lodash';
import { TState } from '../../RootReducer'
import ChipSelect from '../ChipSelect'
import { WithTranslationProps, withTranslations } from '../../Features/Translations/withTranslations'
import { METADATA_ICC_NAME, METADATA_INTER_LOCUTORY_APPEAL_NO, METADATA_IS_COURT_RECORD } from '../../Features/Translations/translationKeys.ltd'

interface IProps extends WithStyles<typeof STYLES>, IStateProps, IDispatchProps { }


interface IStateProps {
    formData: Record<string, any>
    includeIdOptions: Record<string, any>
}

interface IDispatchProps {
    setFormField: (key: string, value: any) => void
    confirmationDialog: (msg: string, onConfirm: Function, onCancel: Function) => void,
}


class ICCDocuments extends Component<IProps & WithTranslationProps> {

    handleChange = (e: any) => {
        if (this.props.setFormField) {
            this.props.setFormField(e.target.name, e.target.value)
        }
    }
    handleSelectChange = (e: any) => {
        if (this.props.setFormField) {
            this.props.setFormField(e.target.name, [e.target.value])
        }
    }

    handleSelect = (key: string, value: any) => {
        if (this.props.setFormField) {
            this.props.setFormField(key, value)
        }
    }

    render() {
        const { classes, formData, includeIdOptions, getTranslation } = this.props

        const FORM_CONFIG: IFormConfig[][] = [
            [
                {
                    label: 'component', key: 'isCourtRecord', type: 'component', onChange: this.handleChange, component: (
                        <div className="flex-row space-between">
                            <ChipSelect formkey="isCourtRecord" value={formData['isCourtRecord']} title={getTranslation(METADATA_IS_COURT_RECORD) || 'Is court record'} onChange={this.handleSelect} options={BOOLEAN_OPTIONS} />
                        </div>
                    )
                }
            ],
            [
                { label: 'ICC situation name', key: 'iccSituationIds', type: 'select', options: _.get(includeIdOptions, 'iccSituations'), onChange: this.handleSelectChange, translationKey: METADATA_ICC_NAME },
            ],
            [
                { label: 'Interlocutory appeal no.', key: 'interlocutory', type: 'multiline', onChange: this.handleChange, translationKey: METADATA_INTER_LOCUTORY_APPEAL_NO },
            ],
        ]

        return (
            <>
                <FormGroup classes={{ root: classes.formContainer }} formData={formData} formItems={FORM_CONFIG} />
            </>
        )
    }
}

const STYLES = (theme: Theme) => createStyles({
    formContainer: {
        [theme.breakpoints.down('sm')]: {
            width: '95vw',
        }
    }
})

const mapStateToProps = (state: TState): IStateProps => ({
    ..._.pick(state.NewLTDDocument, ['formData']),
    includeIdOptions: _.get(state.App, 'ltdIncludeOptions'),
});

const mapDispatchToProps = (dispatch): IDispatchProps => ({
    setFormField: (k: string, v: any) => dispatch(ONewLTDDocument.setFormField(k, v)),
    confirmationDialog: (msg: string, onConfirm: Function, onCancel: Function) => dispatch(OApp.showConfirmationDialog(msg, onConfirm, onCancel)),

})

export default withStyles(STYLES)(connect(mapStateToProps, mapDispatchToProps)(withTranslations(ICCDocuments)))